import CoreMixin from '@/mixins/core.mixin';
import DataTableLayout from '@/modules/shared/components/core/layouts/DataTableLayout.vue';
import DataTableActions from '@/modules/shared/components/core/datatable/DataTableActions.vue';
import NoData from '@/modules/shared/components/core/datatable/NoData.vue';
import ModalFormLayout from '@/modules/shared/components/core/layouts/ModalFormLayout.vue';
import ConfirmationModal from '@/modules/shared/components/core/modals/ConfirmationModal.vue';
import AccessControlMixin from '@/mixins/accessControl.mixin';
import { formatTelephoneNumber as normalizeTelephoneNumber } from '@/lib/phone-number';

export default {
  mixins: [CoreMixin, AccessControlMixin],
  components: {
    NoData,
    DataTableLayout,
    DataTableActions,
    ModalFormLayout,
    ConfirmationModal
  },
  methods: {
    getRandomColor() {
      return (
        '#' +
        Math.floor(Math.random() * 16777215)
          .toString(16)
          .padStart(6, '0')
      );
    },

    chartColors(array) {
      return array.map(() => this.getRandomColor());
    },

    formatTelephoneNumber(value) {
      return normalizeTelephoneNumber(value);
    },

    allowOnlyTelephoneDigits(event) {
      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },

    removeUnderscoresAndCapitalize(txt) {
      if (!txt) {
        return '';
      } else {
        return txt
          .toLowerCase() // make all lowercase
          .split('_') // split by underscore
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize each word
          .join(' ');
      }
    }
  }
};
